module.exports = __webpack_public_path__ + "static/img/ground.778e26eb.png";